import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { colors } from '@guryou/colors';
import { ProviderTypes } from '@guryou/core';
import { Block, ContainedButton, Form, ImageLogo, LinkButton, MediumText, OutlinedButton, SmallText, TextBox } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { createUserAndProvider, stateIsLoading, useEffectOnSuccess } from '@guryou/redux';
import { isValidEmail } from '@guryou/utils/build/stringUtils';
import { Checkbox } from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import logo from '../../assets/img/guryouLogos/gyLogo08.png';

const ProviderGeneralInfo = ({ state, setState, goToStep }) => {
  const { t } = useTranslation();
  const providerType = state?.type;
  const [invalidEmail, setInvalidEmail] = useState(false);
  const [checkbox, setCheckbox] = useState();
  const dispatch = useDispatch();

  const { width } = useSelector(state => state.windowSize);

  const isItMobile = width < 600;

  const register = useSelector(state => state.user.createUser);

  const handleBack = () => {
    goToStep(1);
  };

  useEffectOnSuccess([state => state.user.createUser], data => {
    setState(prev => ({ ...prev, user: data || {} }));
    goToStep(3);
  });

  const handleSubmit = data => {
    setInvalidEmail(false);
    setState(prev => ({ ...prev, submitted: true, ...data }));
    const validEmail = isValidEmail(data.email) && data.email;
    if (!validEmail) {
      setInvalidEmail(true);
      return;
    }
    const category = providerType === 'C' ? 4 : 35; // 4(C) - Palestre , 35(P) - Istruttore
    const providerName = data.name;
    const phone = data.phone;
    if (providerType && validEmail && providerName && phone) {
      dispatch(
        createUserAndProvider({
          email: validEmail,
          providerName,
          providerType,
          category,
          role: 'owner',
          agreements: [
            { type: 'marketing', decision: false },
            { type: 'email', decision: false },
          ],
          phone,
          tags: 'rimini-wellness',
        })
      );
    }
  };

  const registerLoading = stateIsLoading(register);

  return (
    <Form onSubmit={handleSubmit} actions={false}>
      <Block xs={12} display="flex" flexDirection="column" alignItems="center" justifyContent="center" marginTop={isItMobile ? 4 : 10}>
        <Block
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          maxWidth="400px"
          width="100%"
          margin={0}
          marginTop={4}
          marginBottom={2}
          background="#fbfdff"
          border={borderDefinition()}
          borderRadius={smallBorderRadius}
          boxShadow="0 2px 8px rgba(0, 0, 0, 0.04)"
        >
          <Block xs={12} margin={0} padding={4} paddingTop={0} maxWidth="400px" width="100%">
            <Block margin={0} marginTop={4} textAlign="center">
              <ImageLogo src={logo} />
            </Block>
            <TextBox
              lg={12}
              md={12}
              xs={12}
              fullWidth
              label={providerType === ProviderTypes.centers ? t('RIMINI_REGISTER.centerName') : t('RIMINI_REGISTER.professionalName')}
              margin="10px 0px 10px 0px"
              name="name"
              required
            />
            <TextBox xs={12} type="email" fullWidth label={t('GENERAL.email')} margin="10px 0px 14px 0px" name="email" required />
            <TextBox xs={12} fullWidth label={t('GENERAL.phone')} margin="10px 0px 14px 0px" name="phone" required />
          </Block>
          <FormControlLabel
            control={<Checkbox value={checkbox} onChange={() => setCheckbox(!checkbox)} style={{ color: colors.mineShaft }} name="checkedC" />}
            label={
              <MediumText textAlign="left" color={colors.mineShaft} fontSize="0.9rem" fontWeight={600}>
                {t('CONTENT.iAcceptPrivacyPolicy')}
              </MediumText>
            }
          />
          <Block margin={0} padding={2}>
            <MediumText textAlign="center" color={colors.mineShaft} fontSize="0.9rem" fontWeight={400} marginTop={2} marginBottom={2}>
              {t('CONTENT.consultThe')}{' '}
              <LinkButton color={colors.mineShaft} borderBottom="1px solid black" to={process.env.REACT_APP_PRIVACY_POLICY}>
                {t('FOOTER.privacyPolicy')}
              </LinkButton>{' '}
              {t('MODALS.and')}{' '}
              <LinkButton color={colors.mineShaft} borderBottom="1px solid black" to={process.env.REACT_APP_TERMS_AND_CONDITIONS}>
                {t('FOOTER.terms')}
              </LinkButton>
            </MediumText>
          </Block>
          <SmallText padding={2} color="#e6616a">
            {invalidEmail && t('RIMINI_REGISTER.invalidEmail')}
          </SmallText>
          <SmallText padding={2} color="#e6616a">
            {!register.status && register.errors && register.errors[0].message}
          </SmallText>
        </Block>
        <Block display="flex" justifyContent="space-between" gap={2} margin={0} maxWidth="400px" width="100%" flexWrap="wrap">
          <OutlinedButton fullWidth onClick={handleBack} disabled={registerLoading} marginLeft={0} marginRight={0}>
            {t('RIMINI_REGISTER.back')}
          </OutlinedButton>
          <ContainedButton
            fullWidth
            color="secondary"
            type="submit"
            disabled={!checkbox || registerLoading}
            loading={registerLoading}
            marginLeft={0}
            marginRight={0}
          >
            {t('RIMINI_REGISTER.getPromotion')}
          </ContainedButton>
        </Block>
      </Block>
    </Form>
  );
};

export default ProviderGeneralInfo;
